import React from 'react';
import './ClubEmpresarialPage.css';
import Header from './Header';
import Footer from './Footer';
import { 
  FaNetworkWired, 
  FaGraduationCap, 
  FaUsers, 
  FaShareAlt,
  FaHandshake,
  FaLightbulb,
  FaChartLine,
  FaBullhorn,
  FaEye,
  FaRocket
} from 'react-icons/fa';

const ClubEmpresarialPage = () => {
  return (
    <>
      <Header />
      <main className="club-empresarial-page">
        {/* Hero Section */}
        <div className="club-hero">
          <div className="container">
            <h1 className="club-hero-title">
              CLUB <span className="club-hero-title-gold">EMPRESARIAL</span>
            </h1>
            <p className="club-hero-subtitle">
              Una comunidad que se capacita, se conecta y avanza unida
            </p>
          </div>
        </div>

        <div className="club-content">
          <div className="container">
            {/* Sección NETWORKING */}
            <section className="club-section">
              <h2 className="club-section-title">
                <span className="club-section-title-gold">NETWORKING</span>
              </h2>
              <div className="club-section-content">
                <div className="club-text-content">
                  <p className="club-paragraph">
                    En el Club Recomienda-T diseñamos experiencias de networking disruptivas y significativas, donde el objetivo no es solo intercambiar contactos, sino conectar persona con persona.
                  </p>
                  <p className="club-paragraph">
                    A través de dinámicas únicas, fomentamos la confianza, la cercanía y las alianzas estratégicas que generan negocios reales.
                  </p>
                  <p className="club-paragraph">
                    Creemos que los lazos empresariales más fuertes comienzan con una conversación auténtica.
                  </p>
                </div>
                <div className="club-icon-wrapper">
                  <FaNetworkWired className="club-section-icon" />
                </div>
              </div>
            </section>

            {/* Sección MASTER CLASS */}
            <section className="club-section">
              <h2 className="club-section-title">
                <span className="club-section-title-gold">MASTER CLASS</span>
              </h2>
              <div className="club-section-content">
                <div className="club-icon-wrapper">
                  <FaGraduationCap className="club-section-icon" />
                </div>
                <div className="club-text-content">
                  <p className="club-paragraph">
                    Recibirás mentoría en áreas clave de negocios.
                  </p>
                  <p className="club-paragraph">
                    Además de adquirir conocimientos prácticos y actualizados, tendrás la oportunidad de generar conexiones estratégicas con otros emprendedores y empresarios que, como tú, buscan crecer y evolucionar.
                  </p>
                  <p className="club-paragraph">
                    Formamos una comunidad que se capacita, se conecta y avanza unida.
                  </p>
                </div>
              </div>
            </section>

            {/* Sección FOCUS GROUP */}
            <section className="club-section">
              <h2 className="club-section-title">
                <span className="club-section-title-gold">FOCUS GROUP</span>
              </h2>
              <div className="club-section-content">
                <div className="club-text-content">
                  <p className="club-paragraph">
                    Crecerás en un ambiente de apoyo y motivación impulsado por otros empresarios que comparten tu visión.
                  </p>
                  <p className="club-paragraph">
                    Encuentro <strong>mensual</strong> exclusivo donde los <strong>miembros Gold</strong> pueden exponer los retos de sus negocios y recibir feedback valioso de otros miembros para encontrar soluciones y mejorar sus empresas.
                  </p>
                  <div className="club-benefits-list">
                    <div className="club-benefit-item">
                      <FaLightbulb className="club-benefit-icon" />
                      <div>
                        <h3 className="club-benefit-title">Feedback especializado</h3>
                        <p className="club-benefit-text">
                          Obtén perspectivas y soluciones de otros empresarios con experiencia, ayudando a resolver problemas de manera más efectiva.
                        </p>
                      </div>
                    </div>
                    <div className="club-benefit-item">
                      <FaHandshake className="club-benefit-icon" />
                      <div>
                        <h3 className="club-benefit-title">Networking estratégico</h3>
                        <p className="club-benefit-text">
                          Fortalece tu red de contactos con otros miembros Gold, creando oportunidades de colaboración y crecimiento conjunto.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="club-icon-wrapper">
                  <FaUsers className="club-section-icon" />
                </div>
              </div>
            </section>

            {/* Sección DIFUSIÓN EN REDES SOCIALES */}
            <section className="club-section">
              <h2 className="club-section-title">
                DIFUSIÓN EN REDES <span className="club-section-title-gold">SOCIALES</span>
              </h2>
              <div className="club-section-content">
                <div className="club-icon-wrapper">
                  <FaShareAlt className="club-section-icon" />
                </div>
                <div className="club-text-content">
                  <p className="club-paragraph club-highlight">
                    Incrementarás la visibilidad de tu empresa y te ayudaremos a posicionar tu marca y destacar en la comunidad.
                  </p>
                  <p className="club-paragraph">
                    Los miembros del club disfrutan de visibilidad destacada en nuestras redes sociales, lo que les permite aumentar su presencia online y conectar con un público más amplio.
                  </p>
                  <div className="club-benefits-section">
                    <h3 className="club-benefits-title">Beneficios principales:</h3>
                    <div className="club-benefits-list">
                      <div className="club-benefit-item">
                        <FaEye className="club-benefit-icon" />
                        <div>
                          <h3 className="club-benefit-title">Mayor visibilidad</h3>
                          <p className="club-benefit-text">
                            Expón tu negocio a una audiencia más amplia en plataformas clave.
                          </p>
                        </div>
                      </div>
                      <div className="club-benefit-item">
                        <FaChartLine className="club-benefit-icon" />
                        <div>
                          <h3 className="club-benefit-title">Aumento de oportunidades</h3>
                          <p className="club-benefit-text">
                            Genera más contactos y clientes potenciales gracias a la difusión en redes.
                          </p>
                        </div>
                      </div>
                      <div className="club-benefit-item">
                        <FaRocket className="club-benefit-icon" />
                        <div>
                          <h3 className="club-benefit-title">Fortalecimiento de marca</h3>
                          <p className="club-benefit-text">
                            Refuerza tu presencia digital y establece tu negocio como referente en tu sector.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ClubEmpresarialPage;


